import { render, staticRenderFns } from "./PermissionManagement.vue?vue&type=template&id=7aca18a2&scoped=true"
import script from "./PermissionManagement.vue?vue&type=script&lang=js"
export * from "./PermissionManagement.vue?vue&type=script&lang=js"
import style0 from "./PermissionManagement.vue?vue&type=style&index=0&id=7aca18a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aca18a2",
  null
  
)

export default component.exports